
export default {
    name: "GYMLoader",
    data: () => ({
        loaderType: 'default'
    }),

    props: ['logo']
}
